import { render, staticRenderFns } from "./PolygonsCanvas.vue?vue&type=template&id=e56ee3d8&scoped=true&"
import script from "./PolygonsCanvas.vue?vue&type=script&lang=js&"
export * from "./PolygonsCanvas.vue?vue&type=script&lang=js&"
import style0 from "./PolygonsCanvas.vue?vue&type=style&index=0&id=e56ee3d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56ee3d8",
  null
  
)

export default component.exports